// Inspired by the Facebook spinners.
import {makeStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

const useStylesFacebook = makeStyles({
  root: {
    position: 'relative',
    // paddingLeft:0,
    paddingRight: 5,
    paddingTop: 5,
  },
  top: {
    color: '#eef3fd',
  },
  bottom: {
    color: '#6798e5',
    animationDuration: '550ms',
    position: 'absolute',
    left: 0,
  },
});

const FacebookProgress = (props) => {
  const classes = useStylesFacebook();

  return (
    <div className={classes.root}>
      <CircularProgress variant="determinate" value={100} className={classes.top} size={24} thickness={4} {...props} />
      <CircularProgress variant="indeterminate" disableShrink className={classes.bottom} size={24} thickness={4} {...props} />
    </div>
  );
};
export default FacebookProgress;
